import { Component, OnInit, Input } from '@angular/core';
import { FormValidationError } from '../get-form-validation-errors';

@Component({
  selector: 'form-errors-control',
  templateUrl: './form-errors-control.component.html',
  styleUrls: ['./form-errors-control.component.scss']
})
export class FormErrorsControlComponent implements OnInit {

  @Input() errors: FormValidationError[] = [];

  constructor() { }

  ngOnInit() {
  }

}
